import React, {useState} from 'react';
import {companyDetails} from './companyData';
import JobList from "../../components/jobList";
import SwiperComponent from "../swiper";
import './index.less'
export default function CompanySelector() {
    // 选中的公司 ID（默认第一个键）
    const companyKeys = Object.keys(companyDetails);
    const [selectedCompanyId, setSelectedCompanyId] = useState(companyKeys[0]);
    const selectedDetail = companyDetails[selectedCompanyId];

    return (
        <div className="company-selector-container">
            <div className="company-selector-inner">
                <div className="company-selector">
                    <div className="company-list">
                        <div className="company-list-title">选择子公司</div>
                        <ul className="company-list-items">
                            {companyKeys.map(id => (
                                <li
                                    key={id}
                                    className={selectedCompanyId === id ? 'active' : ''}
                                    onClick={() => setSelectedCompanyId(id)}
                                >
                                    {companyDetails[id].title}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="company-detail">
                        <h2>{selectedDetail?.title}</h2>
                        {selectedDetail && (
                            <div className="company-content">
                                <div className="company-description">
                                    {selectedDetail.description.map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))}
                                </div>
                                {Array.isArray(selectedDetail?.images) && selectedDetail.images.length > 0 && (
                                    <div className="company-images">
                                        <SwiperComponent images={selectedDetail.images} />
                                    </div>
                                )}
                                {selectedDetail?.contact && (
                                    <div className="company-contact">
                                        {(selectedDetail?.contact?.person?.trim() || selectedDetail?.contact?.phone?.trim()) && (
                                            <p>联系人: {selectedDetail.contact.person} {selectedDetail.contact.phone}</p>
                                        )}
                                        {selectedDetail.contact?.email && (
                                            <p>邮箱: {selectedDetail.contact.email}</p>
                                        )}
                                        {selectedDetail?.contact?.address?.trim() && (
                                            <p>公司地址: {selectedDetail.contact.address}</p>
                                        )}
                                        {selectedDetail.contact?.website && (
                                            <p>公司网址: <a href={selectedDetail.contact.website}
                                                            target="_blank"
                                                            rel="noopener noreferrer">{selectedDetail.contact.website}</a>
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {!selectedDetail && (
                            <div className="company-content">
                                <p>暂无该公司详细信息，请联系管理员添加。</p>
                            </div>
                        )}
                        <JobList
                            searchParams={{}}
                            jobKind={'6'}
                            jobSearchTag={selectedDetail?.jobSearchTag || "ebfee63e9452481e0ba177c679c3691d"}
                        />
                    </div>

                </div>

            </div>
        </div>
    );
}